<template>
  <div class="appointment-wrap"
    v-loading="loading"
      element-loading-text="正在查询预约信息，请稍后~"
      element-loading-spinner="el-icon-loading"
   >
    <div class="appointment-content" style="height:calc(100% + 1px);">
      <div class="appointment-back"></div>
      <div class="appointment-top">
        <div class="appointment-top-text">预约人信息</div>
        <div>
          <div class="appointment-top-text">姓名</div>
          <div style="margin-top: 0.1rem;"><input type="text" placeholder="请输入姓名" v-model="userName"> </div>
        </div>
        <div>
          <div class="appointment-top-text">身份证</div>
          <div style="margin-top: 0.1rem;"><input type="text" placeholder="请输入身份证号" v-model="idCardNumber"> </div>
        </div>
      </div>
      <div class="appointment-bottom">
        <div class="appointment-top-text" style="margin: 0px 0.15rem;"><div>预约时间</div> <div v-if="!checkTime">{{ appointmentTime ?  appointmentDate + dateFilter(appointmentTime) : ''}}</div></div>
        <div class="appointment-date-conten">
          <div class="appointment-date" v-for="item in appointmentInfo" :key="item.id" @click="dateConfig(item)">
            <div >{{item.date}}</div>
            <div class="vertical-box"><span>余号</span> <span>{{item.surplus}}</span> <span> &nbsp;<i class="iconfont iconxiala" style="color: #007B83;font-size:0.14rem"></i></span></div>
          </div>
        </div>
      </div>
      <div class="appointment-button">
        <div><el-button style="background:#007B83;color:#fff;border:none;padding:4%;" @click="getAppointment">确定</el-button></div>
        <div><el-button style="margin: 0.2rem 0px;background:rgba(0,123,131,0.1);border:1px solid rgba(0,123,131,1);color:#007B83;padding:4%;" @click="exitAppointment">取消</el-button></div>
      </div>
      <div class="mark-time" v-if="markFlag"  
        v-loading="loadingAppointment"
        element-loading-text="正在预约请稍后"
        element-loading-spinner="el-icon-loading"
        element-loading-color="#00CABF"
        element-loading-background="rgbargba(0, 0, 0, 0.8)">
        <!-- 时间选择 -->
        <div class="mark-box" v-if="checkTime">
          <div class="mark-box-top">
            <div style="color:#999999" @click="markFlag = false;checkTime = false;appointmentTime =''">取消</div>
            <div style="color: #007B83;" @click="markFlag = false;checkTime = false">确定</div>
          </div>
          <div class="mark-box-date"  @click.stop="checkTimeEvent">
            <div v-for="(item, index) in appointmentTimeInfo" :key="index" class="mark-time-box" @click="appointmentTime = item.time" :class="[item.appointmentNumber <= 0 ? 'noclick' : ' ']">
              <div>{{item.time}}</div>
              <div class="mark-time-title">
                余号:{{item.appointmentNumber}}
              </div>
            </div>
          </div>
        </div>
        <!-- 预约结果 -->
        <div v-else>
          <!-- 成功 -->
          <div class="mark-box-success" v-if="appointmentResult">
            <div class="mark-success-exit"><span @click="markFlag = false;"><i class="iconfont iconguanbi" @click="goHome"></i></span></div>
            <div><img style="margin: 0 auto;width:2rem;height:1.2rem" src="../../assets/image/appointmentSucceed.png" alt=""></div>
            <div style="margin: 0.1rem 0.2rem;">
              <div>恭喜您，预约成功！ </div>
              <div>请您本人务必携带身份证及用户服务卡，按预约时间准时到收费大厅办理业务，逾期预约失效</div>
            </div>
            <div>
              <el-button style="height: 0.3rem;line-height:0.02rem;background:#007B83;border:none;color:#fff;margin-top:0.05rem" @click="goHome">确定</el-button>
            </div>
          </div>
          <!-- 失败 -->
          <div class="mark-box-fail" v-else>
            <div class="mark-success-exit"><span @click="markFlag = false;"><i class="iconfont iconguanbi" @click="goHome"></i></span></div>
            <div><img style="margin: 0 auto;width:2rem;height:1.2rem" src="../../assets/image/appointmentFail.png" alt=""></div>
            <div style="margin: 0.2rem 0.2rem;">
              <div style="color:#999999">抱歉，您的在线预约失败了！ </div>
            </div>
            <div>
              <el-button style="height: 0.3rem;line-height:0.02rem;background:#007B83;border:none;color:#fff" @click="goHome;">确定</el-button>
            </div>
          </div>
        </div>
      </div>
      <div class="mark-hint" v-if="hintFlag">
        <div>
          <div style="text-align: right;padding:0.1rem 0.15rem;color:#AAAAAA"><i class="iconfont iconguanbi" @click="hintFlag = false"></i></div>
          <div style="color:#007B83;margin-top:0.14rem">
            <div>
              <div style="padding: 0rem 0.3rem;">{{textHint}}</div>
              <div v-if="hintFlag2">请重新检查您的信息~</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
  </div>
</template>
<script>
import moment, { months } from 'moment';

export default {
  name: 'appointment',
  data(){
    return{
      appointmentInfo:[],// 可预约时间与余号人数
      loadingAppointment:false,// 预约进行时的loading
      loading:false,
      markFlag:false,// 遮罩层
      checkTime:false,// 预约时间列表的隐藏与显示
      appointmentResult:false,// 预约结果 true成功 false 失败
      appointmentTimeInfo:[],//所有可选择的date
      idCardNumber:'',// 身份证号
      userName:'',//用户姓名
      alreadyAppointment:[], // 已经预约的名单信息
      appointmentDate:'', // 用户选择的预约日期
      appointmentTime:'',// 用户选择的预约时间
      textHint:'',// 提示信息
      hintFlag:false,
      hintFlag2:true,
    }
  },

  methods:{
    // 获取当前点击日期的可预约时间
    async dateConfig(item){
      this.appointmentTimeInfo = [];
      this.appointmentDate = item.date;
      this.markFlag = true, this.checkTime = true;
      // 获取所有已预约信息
      const res = await this.$http.get(`${this.$url.globalurl}/wxAppointment`,{
        data:{
          startDate:moment(item.date).format("YYYY-MM-DD"),
          id:sessionStorage.getItem('customer_id')
        }
      });
      this.alreadyAppointment = res.result;
      // 获取预约设置

      const systemConfigRes = await this.$http.get(this.$url.globalurl + `/systemConfig/${sessionStorage.getItem('customer_id')}`);
      let currentTime = moment(item.date).format('YYYY-MM-DD')+' '+systemConfigRes.result[0].open_reservation_time.split('~')[0]; // 点击日期的最早预约时间（while循环的步长值）
      // 
      while(moment(currentTime).isBefore(item.date+' '+systemConfigRes.result[0].open_reservation_time.split('~')[1])) {
          let reservationNum = 0;
          for(let item of this.alreadyAppointment){
            if(moment(item.reservation_time).isBetween(currentTime, moment(currentTime).add(Number(systemConfigRes.result[0].reservation_interval_time), 'minutes').format('YYYY-MM-DD HH:mm:ss'), null, '[)')){
              reservationNum++;
            }
          }  

          if(moment(moment(currentTime).add(Number(systemConfigRes.result[0].reservation_interval_time), 'minutes').format('YYYY-MM-DD HH:mm:ss')).isAfter(moment())){
            this.appointmentTimeInfo.push({
              time:moment(currentTime).format('HH:mm:00'),
              appointmentNumber: systemConfigRes.result[0].reservation_interval_people-reservationNum
            }) 
          }
          currentTime = moment(currentTime).add(Number(systemConfigRes.result[0].reservation_interval_time), 'minutes').format('YYYY-MM-DD HH:mm:ss')
      }  
    },
    dateFilter(time){
      return ' ' + time.substring(0,5);
    },
     // 获取可预约信息
    async getAppointmentInfo(){
      // 当前时间
      const currentTime = moment().format('YYYY-MM-DD HH:mm:00');
      const res = await this.$http.get(`${this.$url.globalurl}/wxAppointment`,{
        data:{
          currentTime,
          id:sessionStorage.getItem('customer_id')
        }
      });
      // 获取预约信息设置
      const appointmentConfig = await this.$http.get(`${this.$url.globalurl}/systemConfig/${sessionStorage.getItem('customer_id')}`);
      let open_day = appointmentConfig.result[0].open_day;
      open_day ? open_day : open_day = 3;
      let appointmentInfo = [];
      for(let i = 0; i < open_day; i++){
        const appointment = {
          date:moment().add(open_day + i, 'days').format("YYYY-MM-DD"),// 时间
          surplus:'' // 预约人数
        }
        appointmentInfo.push(appointment)
      }
      res.result.forEach((i,index)=>{
        appointmentInfo[index].surplus = i;
      })
      this.appointmentInfo = appointmentInfo; 
      this.loading = false;
    },
    // 改变dom节点的样式
    checkTimeEvent(e){
      let fa = document.getElementsByClassName('mark-box-date')
      for(let item of fa[0].children){
        item.classList.remove('selectStyle');
      }
      if(!e.target.children.length){ // 点击子元素时
        const parentDom = e.target.parentElement;
        parentDom.classList.add('selectStyle')
      }
     
    },
    // 预约请求
    async getAppointment(){
      if(!this.userName || !this.idCardNumber || !this.appointmentTime){
        this.hintFlag = true;
        this.hintFlag2 = false;
        return this.textHint = '抱歉！请您填写完预约人信息后， 再次预约时间~';
      }
      if(!(/^[\u4E00-\u9FA5]{2,4}$/.test(this.userName))){
        this.hintFlag = true;
        this.hintFlag2 = true;
        return this.textHint = '抱歉，您的姓名有误'
      }
      if(!/^[1-9]\d{7}((0\d)|bai(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/.test(this.idCardNumber)){
        this.hintFlag = true;
        this.hintFlag2 = true;
        return this.textHint = '抱歉，您的身份证号码有误'
      }
      this.loadingAppointment = true;
      const res = await this.$http.post(`${this.$url.globalurl}/wxAppointment`,{
          reservation_time: this.appointmentDate+ ' ' + this.appointmentTime,
          reservation_name:this.userName,
          id_card_number:this.idCardNumber,
        });
        if(res.code === 200){
          this.appointmentResult = true;
          this.markFlag = true;
        
        }else{
          this.appointmentResult = false;
          this.markFlag = true;
        }
      this.loadingAppointment = false;
      
    },
    // 预约完成的跳转
    goHome(){
      this.markFlag = false;
      this.$router.replace({
        name:'index'
      })
    },
    // 取消预约
    exitAppointment(){
      this.$router.replace({
        name:'index'
      })
    }
  },
  mounted(){
    this.loading = true;
    this.getAppointmentInfo();
    document.title = "在线预约";
  },
  
}
</script>
<style scoped>
@import url(appointment.scss);
</style>

